(function (window, document) {
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  function set () {
    const o = document.documentElement
    let e = o.getBoundingClientRect().width
    if (e > 600) {
      e = 600
    }
    // document.documentElement.style.fontSize = document.documentElement.clientWidth / 10 + 'px'
    document.documentElement.style.fontSize = e / 10 + 'px'
  }
  window.addEventListener(resizeEvt, set, false)
  document.addEventListener('DOMContentLoaded', set, false)
})(window, document)



// WEBPACK FOOTER //
// ./src/utils/rem.js